module.exports = __webpack_public_path__ + "static/media/it_support.dd41e07b.svg";